interface FuzzyOptions {
  threshold?: number;
}

const normalize = (s: string): string => {
  return s
    .trim()
    .replace(/\(.*?\)/g, "")
    .replace(/[^A-Za-z0-9 ]+/g, "")
    .toLowerCase();
};

const maxToMinDistance = (a: string, b: string): number => {
  const m = a.length,
    n = b.length;
  const dp: number[][] = Array.from({ length: m + 1 }, () =>
    new Array(n + 1).fill(0),
  );
  for (let i = 0; i <= m; i++) dp[i][0] = i;
  for (let j = 0; j <= n; j++) dp[0][j] = j;
  for (let i = 1; i <= m; i++) {
    for (let j = 1; j <= n; j++) {
      const cost = a[i - 1] === b[j - 1] ? 0 : 1;
      dp[i][j] = Math.min(
        dp[i - 1][j] + 1,
        dp[i][j - 1] + 1,
        dp[i - 1][j - 1] + cost,
      );
    }
  }
  return dp[m][n];
};

const similarityRatio = (dist: number, len: number): number => {
  return len === 0 ? 1 : (len - dist) / len;
};

export const fuzzyFinderFuntion = (
  pool: string[],
  rawModel: string,
  options: FuzzyOptions = {},
): string | null => {
  const threshold = options.threshold ?? 0.5;
  const raw = rawModel.trim();

  const exact = pool.find((m) => m.toUpperCase() === raw.toUpperCase());
  if (exact) return exact;

  const normRaw = normalize(raw);

  for (const desc of pool) {
    const normDesc = normalize(desc);
    const wholeWord = new RegExp(`\\b${normDesc}\\b`).test(normRaw);
    const prefix = normRaw.startsWith(normDesc);
    if (wholeWord || prefix) {
      return desc;
    }
  }

  const rawTokens = normRaw.split(" ");
  const numberToken = rawTokens.find((tok) => /^\d+$/.test(tok));
  if (numberToken) {
    const match = pool.find((desc) => {
      const normDesc = normalize(desc);
      const tokens = normDesc.split(" ");
      return tokens.includes(numberToken);
    });
    if (match) {
      return match;
    }
  }

  const scored = pool.map((desc) => {
    const normDesc = normalize(desc);
    const dist = maxToMinDistance(normDesc, normRaw);
    const maxLen = Math.max(normDesc.length, normRaw.length);
    const ratio = similarityRatio(dist, maxLen);
    return { desc, ratio };
  });
  scored.sort((a, b) => b.ratio - a.ratio);

  if (scored[0].ratio >= threshold) {
    return scored[0].desc;
  }
  return null;
};
